var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"hidden-xs-only"},_vm._l((_vm.markedSections),function(item){return _c('li',{key:item.name},[_c('a',{attrs:{"href":("#" + (item.name))}},[_c('span',{class:{
            reverse: item.reverse,
            active: item.active,
          }})])])}),0),_c('ul',{staticClass:"hidden-sm-and-up"},_vm._l((_vm.mobileMarkedSections),function(item){return _c('li',{key:item.name},[_c('a',{attrs:{"href":("#" + (item.name))}},[_c('span',{class:{
            reverse: item.reverse,
            active: item.active,
          }})])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }